<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div class="flex-1 text-right">
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.templateTitile"
          placeholder="请输入模板标题"
          size="small"
          class="ipt mr10"
        ></el-input>

        <el-select
          v-model="searchCondition.templateType"
          placeholder="请选择成团状态"
          size="small"
          clearable
          class="mr10"
        >
          <el-option label="短信" value="sms"></el-option>
          <el-option label="微信" value="wechat"></el-option>
          <el-option label="邮件" value="email"></el-option>
        </el-select>

        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
      </div>
    </div>
    <el-table
      :data="msgTemplatesList.records"
      style="width: 100%"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="模板编码"
        prop="templateCode"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="模板标题"
        prop="templateTitile"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="模板内容"
        prop="templateContent"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="模板类型"
        prop="templateType"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.templateType === 'sms'">短信</span>
          <span v-if="scope.row.templateType === 'wechat'">微信</span>
          <span v-if="scope.row.templateType === 'email'">邮件</span>
        </template>
      </el-table-column>

      <el-table-column
        header-align="center"
        align="center"
        prop="eventName"
        label="触发事件"
      ></el-table-column>

      <!-- <el-table-column
        header-align="center"
        align="center"
        prop="retailPrice"
        label="推送频次"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.retailPrice">¥{{ scope.row.retailPrice }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip class="item" content="编辑" placement="top">
              <div class="pointer mr10" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="msgTemplatesList.total"
        @current-change="paging"
        layout="total,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      title="编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="large-label-form"
      >
        <el-form-item label="模板编码：" prop="templateCode">
          <el-input
            disabled
            size="small"
            clearable
            v-model.trim="ruleForm.templateCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板标题：" prop="templateTitile">
          <el-input
            disabled
            size="small"
            clearable
            v-model.trim="ruleForm.templateTitile"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板类型：" prop="templateType">
          <el-select
            disabled
            v-model="ruleForm.templateType"
            placeholder="请选择成团状态"
            size="small"
            clearable
            class="mr10"
          >
            <el-option label="短信" value="sms"></el-option>
            <el-option label="微信" value="wechat"></el-option>
            <el-option label="邮件" value="email"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息触放事件：" prop="eventName">
          <el-input
            disabled
            size="small"
            clearable
            v-model.trim="ruleForm.eventName"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板内容：" prop="templateContent">
          <el-input
            size="small"
            clearable
            type="textarea"
            v-model.trim="ruleForm.templateContent"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板链接：" prop="templateUrl">
          <el-input
            size="small"
            clearable
            v-model.trim="ruleForm.templateUrl"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信图标">
          <my-upload
            field="file"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            noCircle
            noSquare
            :width="400"
            :height="400"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'mall' }"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <el-button
            type="primary"
            size="small"
            v-show="!listHeaderImgUrl"
            @click="toggleShow"
            >点击上传</el-button
          >

          <div class="flex flex-column flex-end">
            <div class="tips">只能上传jpg/png文件，且不能超过1MB</div>
            <div class="tips">建议图片尺寸为400x400px(最多上传一张）</div>
          </div>
          <div class="priview" v-if="listHeaderImgUrl">
            <img :src="listHeaderImgUrl" alt="主图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="resetForm('ruleForm')">返回</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import myUpload from "vue-image-crop-upload";
export default {
  components: { myUpload },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      searchCondition: {},
      ruleForm: {
        templateContent: "",
        templatePic: "",
        templateUrl: ""
      },
      show: false,
      rules: {
        templateContent: {
          required: true,
          message: "请输入模板内容",
          trigger: "blur"
        }
      },
      listHeaderImgUrl: "",
      storeTemplateId: ""
    };
  },
  computed: mapGetters(["msgTemplatesList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);

      return this.$store.dispatch("msgTemplatesList", params);
    },

    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    edit(row) {
      let params = {
        storeTemplateId: row.storeTemplateId
      };
      this.storeTemplateId = row.storeTemplateId;
      this.dialogVisible = true;
      this.$store.dispatch("detailsMsgTemplates", params).then(res => {
        if (res.code === "0") {
          this.listHeaderImgUrl = res.result.templatePic;
          for (let key in res.result) {
            this.ruleForm[key] = res.result[key];
          }
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.templatePic = this.listHeaderImgUrl;
          let params = this.ruleForm;
          //   let actionName = "";
          //   let params = this[formName];
          //   if (formName === "ruleForm") {
          //     if (this.mode === "add") {
          //       actionName = "addRole";
          //     } else {
          //       actionName = "editRole";
          //       Object.assign(params, { id: this.currentRow.id });
          //     }
          //   }
          Object.assign(params, { storeTemplateId: this.storeTemplateId });
          this.$store.dispatch("editMsgTemplates", params).then(res => {
            if (res.code === "0") {
              this.dialogVisible = false;
              this.queryList();
            }
          });
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    toggleShow() {
      this.show = !this.show;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this[formName]) {
        this[formName][key] = "";
      }
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: #999;
  font-size: 12px;
  line-height: 20px;
}
.priview {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;

  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
